module.exports = __webpack_public_path__ + "img/logout.8e76524d.svg";